import React from 'react';

import ClickableIcon from '~components/ClickableIcon';
import { faEye, faEyeSlash } from '~components/icon';

import Pill from '../pill/Pill';

interface ComponentProps {
  title: string;
  value?: string | number | null;
  pill?: {
    label?: string;
    color?: string;
    icon?: React.ReactNode;
  };
  collapsed?: boolean;
  onToggleCollapse?: () => void;
}

const sanitizeId = (str: string) =>
  str
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

const Statistic: React.FC<ComponentProps> = ({ title, pill, collapsed, value, onToggleCollapse }) => {
  const safeId = sanitizeId(title);

  return (
    <div className="statistic">
      <div className="statistic-header">
        <h3 className="statistic-title">{title}</h3>
        <ClickableIcon
          id={`hide-${safeId}`}
          icon={collapsed ? faEye : faEyeSlash}
          size="x-small"
          shape="round"
          toolTip={collapsed ? 'Show' : 'Hide'}
          onClick={onToggleCollapse}
          color="grey"
          dataCy="statistic-hide"
        />
      </div>
      <div className="statistic-content">
        {!collapsed && <div className="statistic-value">{value}</div>}
        {!collapsed && pill && (
          <Pill color={pill?.color ?? '#000000'} text={pill?.label} icon={pill?.icon} className="statistic-pill" />
        )}
      </div>
    </div>
  );
};

export default Statistic;
